import { Page } from '../../types'

const criminalAction: Page[] = [
    {
        pageType: 'question',
        title: 'Criminal action',
        name: 'criminal-action',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'criminal-action-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'criminal-action-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'criminal-action-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default criminalAction
